import { MiniappEmbed, MiniappEmbedSchema } from 'use-towns-client'

export const parseMiniappEmbed = (rawInfo: unknown): MiniappEmbed | null => {
    if (!rawInfo) {
        return null
    }
    let candidate: unknown = rawInfo
    if (typeof rawInfo === 'string') {
        try {
            candidate = JSON.parse(rawInfo) as unknown
        } catch {
            return null
        }
    }
    const result = MiniappEmbedSchema.safeParse(candidate)
    return result.success ? result.data : null
}
